export const staticContentDefaults = {
  shared: {
    whyChoose: {
      sectionImage: "why-choose.png",
      heading: "Why Choose",
      headingHighlight: "Druyp.",
      headingSuffix: "",
      introParagraph:
        "Freedom, independence, and liberty are priceless. Druyp empowers you to make choices that suit your lifestyle. With Druyp, you decide how much you want to pay, where you want to live, and how you want to live. You can negotiate directly with the property owner, select your preferred location, choose the rental terms that fit your needs, pick the furnishings you desire, and even choose the type of cleaning and cleaner that works best for you. The power of choice is with you, from start to finish",
      features: [
        {
          key: "VisitImg",
          title: "Visit Physically",
          image: "visit.png",
          body: "Our services are primarily online, but if you would like to visit us in person, please contact us to schedule an appointment. Let us know how we can assist you!\nOur business operates remotely and offer virtual assistance.",
          hasReadMore: false,
        },
        {
          key: "HousePlanImg",
          title: "Choose House Plan",
          image: "house-plan.png",
          bodyShort:
            "This option allows tenants to select based on their preferences:\nFurnished Units: Enjoy the convenience and luxury of a fully furnished unit, ready for you to move in.",
          bodyExpanded:
            "Customized Units: Experience the freedom of furnishing the unit to match your personal style and taste.\nThis gives tenants the flexibility to choose what suits them best.",
          hasReadMore: true,
        },
        {
          key: "PeaceImg",
          title: "Live In Peace",
          image: "peace.png",
          body: "True peace comes when you have control over how you live. Peace is found in the power of choice. Choose how you live. Choose your peace.",
          hasReadMore: false,
        },
        {
          key: "AmenitiesImg",
          title: "Amenities",
          image: "amenities.png",
          bodyShort:
            "Amenities Pricing: The pricing is structured in two ways to provide flexibility. In both cases, utilities are included in the rent to ensure an easy transition for tenants moving in and out of the rental unit.",
          bodyExpanded:
            "Rent with Utilities Included: In this option, utilities are already factored into the rent, so the tenant pays a single amount for both rent and utilities.\nRent without Utilities Included: Here, the owner will estimate the average monthly utility usage, and that amount will be added to the rent during payment. This gives tenants a clear choice based on their preferences",
          hasReadMore: true,
        },
      ],
      readMoreLabel: "Read More",
      readLessLabel: "Read Less",
    },
    testimonials: {
      heading: "What",
      headingHighlight: "Our Client",
      headingSuffix: "Says",
      subtext:
        "It's where we show real (or realistic) feedback from people who have used Druyp to build Trust, credibility, and Confidence.",
      items: [
        {
          quote:
            "Druyp Made finding Short - term housing incredibly easy. The process was smooth, Transparent, and Stress-free from start to finish",
          author: "Carolyn Ortiz",
          company: "Prime time housing",
          rating: 5,
          avatar: "user.png",
        },
        {
          quote:
            "I was able to secure a fully furnished place within days. Druyp's platform is reliable, and their team is very professional.",
          author: "Ola Opa",
          company: "Sunbo LLC",
          rating: 5,
          avatar: "user.png",
        },
        {
          quote:
            "As a relocation client, Druyp saved me time and money. Everything was well organized, and the communication was excellent.",
          author: "Ezekiel Solomon",
          company: "",
          rating: 5,
          avatar: "user.png",
        },
        {
          quote:
            "I was able to secure a fully furnished place within days. Druyp's platform is reliable, and their team is very professional.",
          author: "Jay Opa",
          company: "Sunbreco realty llc",
          rating: 5,
          avatar: "user.png",
        },
      ],
    },
  },
  home: {
    hero: {
      searchForm: {
        locationLabel: "Location/House",
        locationPlaceholder: "Enter your Desired Location",
        locationError: "Location is required",
        propertyTypeLabel: "Select Property Type:",
        propertyTypeOptions: [
          { value: "", label: "All" },
          { value: "house", label: "House" },
          { value: "apartment", label: "Apartments" },
          { value: "office", label: "Office" },
          { value: "villa", label: "Villa" },
        ],
        categoryLabel: "Choose category",
        categoryOptions: [
          { id: "all", label: "All" },
          { id: "fullyFurnished", label: "Fully Furnished" },
          { id: "customise", label: "Unfurnished" },
        ],
        searchButton: "Search",
      },
      carouselSlides: [
        { image: "slide1.png" },
        { image: "slide2.png" },
        { image: "slide3.png" },
      ],
      headingParts: {
        beforeSpan1: "Find the ",
        span1: "right home",
        middle: " and ",
        span2: "customize",
        afterSpan2: " to fit your needs",
      },
      subtext:
        "We Help you find the best places and offer near you. Bring to the table win-win survival strategies to ensure proactive domination going forward.",
      quote: "Explore full-service customized short-term rental",
    },
    propertyGallery: {
      headingParts: {
        line1Before: "Personalize your ",
        line1Span: "home.",
        line1Suffix: "",
        line2Before: "Rent a ",
        line2Span: "customizable property",
        line2Suffix: "+",
      },
      ctaText: "view all customizable properties",
      ctaLink: "/properties?house_facility=customize",
      galleryImages: [
        "property6.png",
        "property4.png",
        "property7.png",
        "property5.png",
        "why-choose.png",
        "property6.png",
        "property4.png",
      ],
    },
    trustedPartnersHeader: {
      heading: "Our",
      headingHighlight: "Trusted",
      headingSuffix: "Partners",
      description:
        "Trusted Vendors are service providers, partners or suppliers who have been vetted, verified and approved for their reliability, Quality of service, and professionalism. They consistently meet required standards and can be depended on to deliver services safely and efficiently, and in accordance with agreed terms. They are our partners that you can rely on with confidence.",
    },
    topProperties: {
      heading: "Top Properties",
      viewAllText: "View all properties",
    },
  },
  "about-us": {
    banner: {
      image: "cart-back.png",
      title: "About us",
    },
    aboutContent: {
      heading: "About Druyp as a Marketplace System",
      bodyHtml:
        "Druyp is a comprehensive marketplace system designed to facilitate seamless transactions between property owners, managers, and renters. It serves as a centralized platform where real estate professionals can list, manage, and rent out properties efficiently.<br/><strong> Key features of Druyp as a marketplace system include:</strong><br/><strong>Property Listings –</strong>  Allows landlords and property managers to showcase available rentals.<br/><strong> Tenant Management –</strong>  Streamlines the leasing process, including short-term and long-term rentals.<br/><strong> Secure Transactions – </strong> Ensures safe and reliable financial transactions between parties.<br/><strong> Integrated Communication – </strong> Enables direct communication between property owners and renters.",
    },
    carouselSlides: [
      { badge: "Customise", image: "property1.png" },
      { badge: "Fully Furnished", image: "property2.png" },
      { badge: "Fully Furnished", image: "property3.png" },
    ],
  },
  "contact-us": {
    banner: {
      image: "cart-back.png",
      title: "Contact us",
    },
    sidebarHeading: "Get in Touch with Us",
    contactChannels: [
      {
        type: "phone",
        label: "Phone No.",
        value: "(516) 490-8399",
        icon: "telephone.png",
        href: "#",
      },
      {
        type: "email",
        label: "Email",
        value: "info@druyp.com",
        icon: "mailmessage.png",
        href: "#",
      },
      {
        type: "instagram",
        label: "Instagram",
        value: "@druyp_insta",
        icon: "instagram.png",
        href: "#",
      },
      {
        type: "twitter",
        label: "Twitter",
        value: "@druyp_twitter",
        icon: "twitter.png",
        href: "#",
      },
    ],
    formHeading: "Contact Us",
  },
  "privacy-policy": {
    title: "Privacy Policy for Druyp",
    sections: [
      {
        heading: "Privacy Notice (Summary)",
        body:
          "Druyp collects and uses your personal information to create your account, process bookings and payments, verify identity, prevent fraud, and provide customer support. Your information may be shared with Hosts, payment processors, and trusted service providers only as necessary to deliver our services and comply with the law. Druyp does not sell your personal data. We use reasonable security measures to protect your information. By continuing, you acknowledge that you have read and agree to our Privacy Policy.",
      },
    ],
    contactBlock: {
      name: "Jay Opanike",
      company: "Sunbo llc, A Corporate housing company",
      title: "Owner/ Ceo",
      phone: "(516) 4908399",
      websiteUrl: "https://sunbollc.com/",
      websiteLabel: "https://sunbollc.com/",
    },
  },
  "terms-condition": {
    title: "Terms of service Druyp",
    sections: [
      {
        heading: "Terms Acceptance (Required)",
        body:
          "By completing this booking, you confirm that you have read, understand, and agree to Druyp’s Terms of Service, Booking Terms, and Privacy Policy, and that you are legally authorized to enter into this agreement.",
      },
    ],
    contactBlock: {
      name: "Jay Opanike",
      company: "Sunbo llc, A Corporate housing company",
      title: "Owner/ Ceo",
      phone: "(516) 4908399",
      websiteUrl: "https://sunbollc.com/",
      websiteLabel: "https://sunbollc.com/",
    },
  },
  "booking-terms": {
    title: "Booking terms for druyp",
    sections: [
      {
        heading: "Booking Agreement (Required)",
        body:
          "By checking this box and completing your booking, you confirm that all details are correct; payment will be charged in full at confirmation, and cancellations or refunds are subject to the Host’s stated policy. You agree to follow all Host rules and applicable laws. You understand that Druyp acts only as a booking platform and does not own or operate the listed property, and that liability is limited as permitted by law.",
      },
    ],
    contactBlock: {
      name: "Jay Opanike",
      company: "Sunbo llc, A Corporate housing company",
      title: "Owner/ Ceo",
      phone: "(516) 4908399",
      websiteUrl: "",
      websiteLabel: "",
    },
  },
  thanks: {
    headingHighlight: "Thank You",
    heading: "Your submission is received and we will contact you soon",
    headingSuffix: "",
    ctaText: "Go back to Homepage",
    ctaTarget: "/",
  },
  blog: {
    banner: {
      image: "cart-back.png",
      title: "Blog",
    },
    intro: "",
    emptyText: "No blog posts published yet.",
  },
  footer: {
    tagline: {
      lines: [
        "DRUYP!",
        "Life is too short,",
        "Live your life on your own terms,",
        "Customize your booking.",
      ],
    },
    contact: {
      phone: "(516) 490-8399",
      phoneHref: "#",
      email: "info@druyp.com",
      emailHref: "#",
      instagram: "@druyp_insta",
      instagramHref: "#",
      twitter: "@druyp_twitter",
      twitterHref: "#",
    },
    copyright: "All rights reserved by Druyp",
  },
};
